export function onReady(callback: () => any) {
    if(document.readyState !== "loading") callback();
    else window.addEventListener('DOMContentLoaded', () => callback());
}